<div class="previous-step" *ngIf="taskProcessContext.engagement">
  <div translate="engagement/send-message/choose-message-template/from"></div>
  &nbsp;
  <app-site-icon-and-name [item]="taskProcessContext.site">
    <strong>{{ taskProcessContext.site['label'] }}</strong> </app-site-icon-and-name
  >&nbsp;
  <div translate="engagement/send-message/choose-message-template/to"></div>
  &nbsp;
  <strong>{{ engagementService.strategy.externalUser }}</strong>

  <ion-button (click)="changeRecipient()" size="small" fill="clear">
    <span>{{ 'common/change' | translate }}</span>
  </ion-button>
</div>

<div class="previous-step">
  <span [innerHTML]="'m/task-process/selected-name' | translate: { name: selectedTemplate.name }"></span>

  <ion-button (click)="changeTemplate()" size="small" fill="clear">
    <span>{{ 'common/change' | translate }}</span>
  </ion-button>
</div>
<div class="message-template-composer" *ngIf="selectedTemplate">
  <div class="form-template">
    <div class="message-preview web" *ngIf="isWebMode">
      <ng-container
        [ngSwitch]="taskProcessContext.engagement ? engagementService.strategy.channelType : SiteTypeEnum.WhatsApp">
        <ng-container *ngSwitchCase="SiteTypeEnum.WhatsApp">
          <app-whatsapp-template-preview [templateDisplayedBS]="chooseTemplateFlowService.templateDisplayedBS">
          </app-whatsapp-template-preview>
        </ng-container>
        <ng-container *ngSwitchCase="SiteTypeEnum.Kakaotalk">
          <app-kakaotalk-template-preview [templateDisplayedBS]="chooseTemplateFlowService.templateDisplayedBS">
          </app-kakaotalk-template-preview>
        </ng-container>
      </ng-container>

      <div class="send-buttons">
        <ng-content></ng-content>
      </div>
    </div>
    <div class="form-template-wrapper">
      <div class="inputs-preview-and-button" [style.max-height.px]="inputsPreviewButtonsHeight">
        <div class="header-media-wrapper" *ngIf="selectedTemplate.header?.type === 'media'">
          <ion-button
            *ngIf="!selectedTemplate.header.media_url; else showMedia"
            class="select-media-header-btn"
            (click)="fileInput.click()"
            color="dark"
            fill="clear">
            <span
              *ngIf="selectedTemplate.header.media_type === AttachmentMediaTypeEnum.Image"
              class="image-outline"></span>
            <ion-icon
              *ngIf="selectedTemplate.header.media_type === AttachmentMediaTypeEnum.Document"
              name="attach-outline"></ion-icon>
            <ion-icon
              *ngIf="selectedTemplate.header.media_type === AttachmentMediaTypeEnum.Video"
              name="videocam-outline"></ion-icon>
            &nbsp;{{ uploadMediaTypeLabel }}&nbsp;*
          </ion-button>

          <ng-template #showMedia>
            <img
              *ngIf="selectedTemplate.header.media_type === AttachmentMediaTypeEnum.Image"
              [appJwtSrc]="selectedTemplate.header.media_url" />
            <div *ngIf="selectedTemplate.header.media_type === AttachmentMediaTypeEnum.Document">
              <ion-icon name="document-outline"></ion-icon>
              <a #document target="_blank" [href]="selectedTemplate.header.media_url">
                {{ selectedTemplate.header.filename }}
              </a>
            </div>
            <video
              *ngIf="selectedTemplate.header.media_type === AttachmentMediaTypeEnum.Video"
              class="video"
              [appJwtSrc]="selectedTemplate.header.media_url"
              width="50%"
              preload=""
              controls=""></video>

            <div class="buttons-media-wrapper" *ngIf="!selectedTemplate.header.static">
              <ion-button (click)="fileInput.click()" size="small" fill="clear">
                <span class="button-media"> {{ editMediaTypeLabel }} </span>
              </ion-button>
              <ion-button (click)="deleteMedia()" size="small" fill="clear">
                <span class="button-media"> {{ deleteMediaTypeLabel }} </span>
              </ion-button>
            </div>
          </ng-template>

          <input #fileInput (change)="uploadMedia($event)" [accept]="supportedMediaTypes" hidden type="file" />
        </div>

        <ion-item *ngFor="let parameter of selectedTemplate.parameters">
          <ion-label aria-required="true" position="floating">
            <span>{{ 'm/task-process/input-parameter-label' | translate: { field: parameter.placeholder } }}</span>
          </ion-label>
          <ion-input required [(ngModel)]="parameter.value" (ionChange)="checkMessageValidity()"></ion-input>
        </ion-item>

        <ng-container *ngFor="let control of urlButtonsFormArray.controls || []; index as index">
          <div class="url-button-wrapper">
            <ion-item *ngIf="selectedTemplate.urlButtons[index]">
              <ion-label aria-required="true" position="floating">
                <span>{{
                  'm/task-process/button-parameter-label'
                    | translate: { field: selectedTemplate.urlButtons[index].text }
                }}</span>
              </ion-label>
              <ion-input disabled [ngModel]="selectedTemplate.urlButtons[index].url"></ion-input>
            </ion-item>
            <ion-item>
              <ion-label aria-required="true" position="floating">
                <span>{{ 'm/task-process/button-parameter-suffix' | translate }}</span>
              </ion-label>
              <ion-input required [formControl]="$any(control)"></ion-input>
            </ion-item>
          </div>
        </ng-container>

        <ng-container *ngFor="let item of selectedTemplate.copyCodeButtons || []">
          <div class="url-button-wrapper">
            <ion-item>
              <ion-label aria-required="true" position="floating">
                <span>{{ 'm/task-process/copy-code-parameter-label' | translate }}</span>
              </ion-label>
              <ion-input
                required
                [formControl]="copyCodeButtonFormControl"
                (ionChange)="checkMessageValidity()"
                maxlength="15"></ion-input>
            </ion-item>
          </div>
        </ng-container>

        <ng-container *ngFor="let control of quickReplyButtonsFormArray.controls || []; index as index">
          <app-select
            [items]="agentShortcuts"
            [control]="control"
            [ionicIcons]="true"
            [enableTypeahead]="true"
            [label]="
              'm/task-process/quick-reply-parameter-label'
                | translate: { field: selectedTemplate.quickReplyButtons[index].text }
            ">
          </app-select>
        </ng-container>
      </div>
      <div class="send-buttons">
        <ng-container *ngIf="!isWebMode">
          <ion-button
            (click)="engagementService.flowStep = EngagementTemplateFlowStepEnum.PREVIEW_AND_SEND_MESSAGE"
            [disabled]="!chooseTemplateFlowService.isValid"
            ><span translate="m/task-process/preview-and-send"></span
          ></ion-button>
        </ng-container>
      </div>
    </div>
  </div>
</div>
